export const formatToET = (date: Date): string => {
  const options: Intl.DateTimeFormatOptions = {
    timeZone: "America/New_York",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  const formatter = new Intl.DateTimeFormat("en-US", options);
  return `${formatter.format(date)} ET`;
};

export const formatToEasternTime = (dateTimeString: Date): string | null => {
  // Parse as local time (no timezone conversion)
  const date = new Date(dateTimeString);

  // Format without timezone conversion - just formatting
  const formatted =
    date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }) + " ET";

  return dateTimeString ? formatted : null;
};
